module.exports = __webpack_public_path__ + "img/delivery-officer.d494c4e3.svg";